"use strict";

// Dropdown
// Open first dropdown item by default
document.querySelectorAll('.dropdown__container').forEach(function (element) {
  var height = element.querySelector('.heading').clientHeight;
  element.style.height = height + "px";
}); // Dropdown click event

document.querySelectorAll('.heading').forEach(function (element, index) {
  element.parentElement.style.height = element.parentElement.clientHeight + "px";
  element.addEventListener('click', function () {
    var inital_height = element.parentElement.querySelector('.heading').clientHeight;
    var final_height = element.parentElement.clientHeight + element.parentElement.querySelector('.metafield-rich_text_field').clientHeight;

    if (element.parentElement.querySelector('.metafield-rich_text_field').classList.contains('visible')) {
      element.parentElement.style.height = inital_height + "px";
    } else {
      element.parentElement.style.height = final_height + "px";
    } // si element ne contient pas active ferme tous les autres élements, on passe cette boucle si on clique sur le meme dropdown pour fair un simple toggle 


    if (!element.classList.contains('active') && document.querySelector('.heading.active') != null) {
      var active = document.querySelector('.heading.active');
      active.classList.remove('active');
      active.parentElement.querySelector('.metafield-rich_text_field').classList.remove('visible');
      active.parentElement.style.height = inital_height + "px";
    } // toggle basique sur un seul dropdown


    element.classList.toggle('active');
    element.parentElement.querySelector('.metafield-rich_text_field').classList.toggle('visible');
    element.parentElement.style.height = +"px";
  });
});
var firstDropdownHeading = document.querySelector('.dropdown__container.first-dropdown .heading');

if (firstDropdownHeading != null) {
  firstDropdownHeading.click();
}